module.exports = __webpack_public_path__ + "img/32.aea00964.jpg";